import { ReactNode } from 'react';
import { Typography } from '@mui/material';

interface Props {
  children: ReactNode;
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

const Header = ({ children, variant = 'h2' }: Props) => {
  return (
    <Typography variant={variant ?? 'h2'} mt={0}>
      {children}
    </Typography>
  );
};

Header.defaultProps = {
  variant: 'h2',
};

export default Header;
